/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export enum FeedbackType {
    Like,
    Dislike
}

export abstract class FeedbackService {
    protected feedbackStartedCallback: ((type: FeedbackType) => void) | undefined

    constructor(feedbackStartedCallback: ((type: FeedbackType) => void) | undefined) {
        this.feedbackStartedCallback = feedbackStartedCallback
    }

    abstract CollectFeedback(type: FeedbackType, componentName: string)
}